import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['email', 'subdomain']

  updateSubdomain() {
    const email = this.emailTarget.value
    const subdomain = this.extractSubdomainFromEmail(email)

    if (subdomain) {
      this.subdomainTarget.value = subdomain
    }
  }

  extractSubdomainFromEmail(email) {
    if (!email || !email.includes('@')) return null

    const domain = email.toLowerCase().trim().split('@').pop()
    if (!domain) return null

    const parts = domain.split('.')
    if (parts.length < 2) return null

    // Take the first part as subdomain base, remove invalid characters
    const subdomain = parts[0].replace(/[^a-z0-9-]/g, '')
    return subdomain || null
  }
}
